export default __webpack_public_path__ + "b49890c1b2f39d14808d0ada8035eb03.woff";